module.exports = __webpack_public_path__ + "img/comment_icon.9303fd0a.svg";